export const summaryCardTablevels = [
  'Analytical data',
  'Review',
  'Assessment',
  'Subscription rating',
  'Public rating',
];
